// extracted by mini-css-extract-plugin
export default {"date":"PostTime_date__8Mgpn"};